import { api } from '@cwd/lib/main';

type Task = {
    TaskId: string;
    ObjectId: string;
    CronExpression: string;
    Scheduled: string;
    TaskStatus: string;
    IsRecurring: boolean; // Recurring status
    TaskType: string;
    TimeZone: string; // Time zone identifier
};

export async function MoveToSent(issueId: string): Promise<void> {
    return api.post(`/Issues/${issueId}/MoveToSent/`);
}

export async function GetIssueSchedule(issueId: string): Promise<Task[]> {
    return api.get(`/Scheduling/${issueId}/Schedules/`);
}

export async function SaveIssueSchedule(issueId: string, schedule: Task): Promise<void> {
    return api.post(`/Scheduling/${issueId}`, schedule);
}
